import { toast } from 'react-toastify';

import { defaultToastOptions } from './consts';
import { Toast } from './Toast';
import type { ToastId, ToastProps } from './types';

export const showToast = (options: ToastProps) => {
  return toast(({ closeToast }) => <Toast onClose={closeToast} {...options} />, {
    ...defaultToastOptions,
    ...options,
  });
};

export const toastSuccess = (options: ToastProps) => showToast({ ...options, variant: 'success' });

export const toastError = (options: ToastProps) => showToast({ ...options, variant: 'error' });

export const toastWarning = (options: ToastProps) => showToast({ ...options, variant: 'warning' });

export const toastInfo = (options: ToastProps) => showToast({ ...options, variant: 'info' });

export const toastDismiss = (toastId?: ToastId) => {
  toast.dismiss(toastId);
};
